import { BILLING_INTERVALS, PLAN_STATUSES } from '@weft/types';
import type { PlanCreationStep } from 'apps/app/src/contexts/create-plan-context/create-plan-context-types/plan-creation-step';
import { PLAN_CREATION_STEPS } from 'apps/app/src/contexts/create-plan-context/create-plan-context-types/plan-creation-step';
import type { DeepPartial } from 'react-hook-form';
import type { PlanInputForm } from '../create-plan-page-components/CreatePlanForm/create-plan-form-types/plan-input-form';

export type StepsCtaLabels = Record<PlanCreationStep, React.ReactNode>;

export const DEFAULT_PLAN_DURATION = 12;

export const CREATE_PLAN_DEFAULT_VALUES: DeepPartial<PlanInputForm> = {
  status: PLAN_STATUSES.Active,
  billingData: {
    billingInterval: BILLING_INTERVALS.Monthly,
    duration: DEFAULT_PLAN_DURATION,
  },
  fixedProducts: [],
  usageProducts: [],
};

export const PLAN_CREATION_STEPS_CTA_LABELS: StepsCtaLabels = {
  [PLAN_CREATION_STEPS.pricingAndProducts]: 'Save Plan & Continue',
  [PLAN_CREATION_STEPS.settings]: 'Confirm & Create Plan',
};
export const CONTRACT_UPDATE_STEPS_CTA_LABELS: StepsCtaLabels = {
  [PLAN_CREATION_STEPS.pricingAndProducts]: 'Save Contract & Continue',
  [PLAN_CREATION_STEPS.settings]: 'Confirm & Update Contract',
}; 

export const CONTRACT_REVISE_STEPS_CTA_LABELS: StepsCtaLabels = {
  [PLAN_CREATION_STEPS.pricingAndProducts]: 'Save Contract & Continue',
  [PLAN_CREATION_STEPS.settings]: 'Confirm & Revise Contract',
};